<template>
  <div>
    <PageHead title="操作日志"></PageHead>
    <div class="oa-layout-content">
      <div class="search-flex">
        <div class="search-flex-item mr20">
          <span>时间范围：</span>
          <a-range-picker
            allowClear
            class="w300"
            v-model="timeHorizon"
            :valueFormat="dateFormat"
          >
            <a-icon slot="schedule" type="smile"
          /></a-range-picker>
        </div>
        <div class="search-flex-item mb20">
          <a-button type="primary" @click="subMit" :loading="loading">
            查询</a-button
          >
          <a-button :style="{ marginLeft: '8px' }" @click="cancel">
            取消
          </a-button>
        </div>
      </div>
      <a-table
        :pagination="false"
        :columns="columns"
        :data-source="logList"
        rowKey="id"
        :loading="loading"
      >
        <span slot="index" slot-scope="text, record, index">
          {{ index + 1 + (page - 1) * 10 }}
        </span>
        <span slot="userName" slot-scope="text, record">
          {{ record.organizationName + ' - ' + record.userName }}
        </span>
        <div slot="action" slot-scope="text, record">
          <a-button type="link" class="btn-link" @click="add(record)">
            编辑
          </a-button>
          <a-divider type="vertical" />
          <a-button
            type="link"
            class="btn-link"
            @click="showDeleteConfirm(record.id)"
          >
            删除
          </a-button>
        </div>
      </a-table>
      <div class="pagination">
        <a-pagination v-model="page" :total="total" @change="pageChange" />
      </div>
    </div>
    <appfloor></appfloor>
  </div>
</template>
<script>
const columns = [
  {
    title: '序号',
    dataIndex: 'index',
    key: 'index',
    width: 80,
    align: 'center',
    scopedSlots: { customRender: 'index' }
  },
  {
    title: '用户',
    dataIndex: 'userName',
    key: 'userName',
    ellipsis: true,
    align: 'left',
    scopedSlots: { customRender: 'userName' }
  },
  {
    title: '操作',
    dataIndex: 'operation',
    key: 'operation',
    ellipsis: true,
    align: 'left'
  },
  {
    title: '动作',
    dataIndex: 'action',
    key: 'action',
    ellipsis: true,
    align: 'left'
  },
  {
    title: '登录IP',
    dataIndex: 'ipStr',
    key: 'ipStr',
    ellipsis: true,
    align: 'left'
  },
  {
    title: '时间',
    dataIndex: 'createTime',
    key: 'createTime',
    ellipsis: true,
    align: 'left'
  }
]
import { getoperationLog } from './api/api'
export default {
  data() {
    return {
      logList: [],
      page: 1,
      size: 10,
      total: 0, //总条数
      timeHorizon: [], //入职时间范围
      dateFormat: 'YYYY-MM-DD',
      columns,
      loading: false
    }
  },

  created() {
    this.load()
  },
  methods: {
    load() {
      this.loading = true
      let params = {}
      if (this.timeHorizon.length > 0) {
        //选择了时间范围
        params.createTimeBefore = this.timeHorizon[0]
        params.createTimeAfter = this.timeHorizon[1]
      }
      params.page = this.page
      params.size = this.size
      getoperationLog(params).then((res) => {
        this.loading = false
        if (res.data.code == 0) {
          this.logList = res.data.data
          this.total = res.data.count
        }
      })
    },
    pageChange(pageNumber) {
      this.page = pageNumber
      this.load()
    },
    cancel() {
      //取消
      this.timeHorizon = []
    },
    subMit() {
      //搜索
      this.page = 1
      this.load()
    }
  }
}
</script>
<style lang="scss" scoped>
.search-flex {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  .search-flex-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/system/operationLog.vue